<p-drawer
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  styleClass="vis-rules-drawer"
  [style]="{ width: '460px', maxWidth: '100vw' }">
  <ng-template #header>
    <div class="vis-rules__header">
      <h3 class="vis-rules__title">Como funciona a visibilidade</h3>
      <p class="vis-rules__subtitle">Vale para todas as calls gravadas pelo Cognito.</p>
    </div>
  </ng-template>

  <div class="vis-rules">
    <section class="vis-rules__section">
      <h4 class="vis-rules__heading">
        <span class="vis-rules__badge vis-rules__badge--on"><i class="pi pi-users"></i></span>
        Time Legatus
      </h4>
      <p>
        Vê quem participou, quem recebeu compartilhamento e, quando a call teve alguém de fora da
        Legatus, todo o time (menos entrevistas). Desligar deixa só quem participou. Ligar à mão
        abre para todo o time, mesmo call interna, como o acesso geral da janela Compartilhar.
      </p>
    </section>

    <section class="vis-rules__section">
      <h4 class="vis-rules__heading">
        <span class="vis-rules__badge vis-rules__badge--on"><i class="pi pi-briefcase"></i></span>
        Parceiro
      </h4>
      <p>
        Só vê a call vinculada a um deal dele, de que ele participou, e cujas empresas são todas dos
        deals dele. A chave só pode tirar o acesso; nunca abre além dessa regra.
      </p>
    </section>

    <section class="vis-rules__section">
      <h4 class="vis-rules__heading">
        <span class="vis-rules__badge vis-rules__badge--off"><i class="pi pi-building"></i></span>
        Cliente
        <span class="vis-rules__soon">em breve</span>
      </h4>
      <p>
        O cliente ainda não vê nenhuma call. A chave já fica gravada para o dia em que o portal do
        cliente abrir. Só pode ficar ligada quando:
      </p>
      <ul>
        <li>
          a call tem empresa-cliente vinculada, e todas as empresas vinculadas são do mesmo cliente;
        </li>
        <li>não é call interna (produto, gestão, recrutamento);</li>
        <li>o Cog já avaliou a call.</li>
      </ul>
      <p>
        Calls de banco, comerciais e de outros tipos, e as de parceiro em que ninguém do cliente
        participou, só vão ao cliente se alguém que participou liberar à mão.
      </p>
    </section>

    <section class="vis-rules__section vis-rules__section--cog">
      <h4 class="vis-rules__heading">
        <i class="pi pi-sparkles" aria-hidden="true"></i>
        O que o Cog avalia
      </h4>
      <p>
        Ao terminar o resumo, o Cog diz se a call pode ir ao cliente e por quê. Ele barra quando há:
      </p>
      <ul>
        <li>
          informação relevante de outro cliente (números, situação, negociação), não só uma citação
          de nome;
        </li>
        <li>palavrão ou linguagem imprópria;</li>
        <li>alguém dizendo que aquilo não é para o cliente ver ou ouvir.</li>
      </ul>
      <p>Por padrão a chave do Cliente segue o Cog.</p>
    </section>

    <section class="vis-rules__section">
      <h4 class="vis-rules__heading">Quem decide e em que ordem</h4>
      <ol>
        <li><strong>Privar</strong> desliga as três chaves de uma vez.</li>
        <li>Decisão de uma pessoa vence o Cog e não volta atrás ao reprocessar.</li>
        <li>As travas acima vencem a sugestão do Cog.</li>
        <li>Sem decisão de ninguém, vale a sugestão do Cog.</li>
      </ol>
      <p>
        Só quem participou da call muda as chaves, o título e usa o Privar. Tudo fica no histórico
        da call.
      </p>
    </section>
  </div>
</p-drawer>
